import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IOrderCardAction, IShopOrderCardData } from 'models/orders/ordercard';
import { getShopOrder } from 'redux/modules/shop/shopordercard';
import { clearData } from 'redux/modules/user/ordercard';
import { IShopCard } from 'models/shop/shopcard';
import { OrderDetails } from 'containers/Common/OrderDetails';
import { getCustomerTabUrl } from 'helpers/common';

interface IProps {
	shopOrderCard?: IShopOrderCardData;
	shopCard?: IShopCard;
	userLanguageKey?: number;
	id?: string;
	params?: IParams;
	location: any;

	/* functions props */
	getShopOrder?: (id: string) => IOrderCardAction;
	clearData?: () => IOrderCardAction;
	t?: (key: string) => string;
}

interface IParams {
	id?: string;
	shopOrderId?: string;
}

interface IState {
	shippingModalOpen: boolean;
}

@connect(
	(state: IStore) => ({
		shopCard: state.shopcard.shopcard,
		shopOrderCard: state.shopOrderCard,
		userLanguageKey: state.userPreferences.languageKey,
	}),
	(dispatch) => ({
		getShopOrder: (id: string) => dispatch(getShopOrder(id, true)),
		clearData: () => dispatch(clearData()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopOrderCard extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		// Prevent extra call if shopOrder already set (if coming from notifications)
		if (
			this.props?.userLanguageKey !== null &&
			this.props.shopOrderCard?.shopOrder?.id !== this.props.params.shopOrderId
		) {
			this.props.getShopOrder(this.props.params.shopOrderId);
		}
	}

	public componentDidUpdate(prevProps: Readonly<IProps>) {
		// Prevent from fetching before moment().locale(culture) is set because otherwise we get the wrong locale and display the wrong language
		// could be a deeper issue in timings of the calls if the problem appears elsewhere
		if (!prevProps?.userLanguageKey && this.props?.userLanguageKey) {
			this.props.getShopOrder(this.props.params.shopOrderId);
		}
	}

	public componentWillUnmount() {
		this.props.clearData();
	}

	public render() {
		const { shopOrderCard, location } = this.props;
		const backUrl = location?.query?.backUrl
			? `${location.query.backUrl}${getCustomerTabUrl('appointments')}`
			: `/shop/${this.props.params.id}/edit/orders`;

		return (
			<div className="shopOrderCard">
				<OrderDetails orderCard={shopOrderCard} viewType="shop" backLink={backUrl} />
			</div>
		);
	}
}

export { ShopOrderCard };
